import React, { useState } from "react";
import styles from "./OrderHistoryDetails.module.css";
import { useNavigate } from "react-router-dom";
import { Modal, SubmitButton, TextComponent } from "../../../../../../components";
import { MdArrowCircleUp } from "react-icons/md";
import {
  IoArrowDownCircleOutline,
  IoArrowUpCircleOutline,
} from "react-icons/io5";
import HeadingComponent from "../../../../../../components/HeadingComponent/HeadingComponent";
import { t } from "i18next";

const OrderHistoryDetails = () => {
  const navigate = useNavigate();
  const [expandedIndex, setExpandedIndex] = useState(0);
  const [CancelModal, setCancelModal] = useState(false);
  const [ProductModal, setProductModal] = useState(false);

  const OrderSummary = [
    {
      id: 1,
      title: "Date Created",
      title_2: "July 23, 2025",
    },
    {
      id: 2,
      title: "Due Date",
      title_2: "July 29, 2025",
    },
    {
      id: 3,
      title: "Order Status",
      title_2: "In Progress",
    },
    {
      id: 4,
      title: "Internal Notes",
      title_2: "None",
    },
    {
      id: 5,
      title: "Order Source",
      title_2: "Call",
    },
  ];
  const CustomerOverview = [
    {
      id: 1,
      title: "Customer Name",
      title_2: "Eddie Lake",
    },
    {
      id: 2,
      title: "Contact",
      title_2: "(785) 712-6532",
    },
    {
      id: 3,
      title: "Location",
      title_2: "605 Dog Hill Lane ",
    },
    {
      id: 4,
      title: "Special Notes",
      title_2: "Low Fat",
    },
  ];
  const OrderedProducts = [
    {
      id: 1,
      title: "Sourdough Bread",
      Quantity: "05",
      AssignedBatchCode: "1523454",
      CurrentStatus: "Completed",
    },
    {
      id: 2,
      title: "French Baguette",
      Quantity: "05",
      AssignedBatchCode: "1523454",
      CurrentStatus: "Completed",
    },
    {
      id: 3,
      title: "French Bastard Sliced",
      Quantity: "05",
      AssignedBatchCode: "1523454",
      CurrentStatus: "Completed",
    },
  ];

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.HeadingDiv}>
        <HeadingComponent
          className={styles.Heading}
          fontSize={"var(--dashboard_tabs-font-size)"}
          text={"Order ID: 78912"}
        />
        <div className={styles.ButtonDiv}>
          <SubmitButton
            title={t("Cancel Order ")}
            secondary
            onClick={() => setCancelModal(true)}
            textClass={styles.TopCancelButtonText}
            btnContainerClass={styles.TopCancelButtonContainer}
            btnClass={styles.TopCancelButton}
          />
          <SubmitButton
            onClick={() => navigate("/AdminCustomerManagement/OrderHistoryEditOrder")}
            title={t("Edit Order")}
            btnClass={styles.TopEditButton}
            primary
            btnContainerClass={styles.TopEditButtonContainer}
            textClass={styles.EditButtonText}
          />
        </div>
      </div>
      <div className={styles.subCont}>
        <div className={styles.leftCont}>
          <HeadingComponent
            text={t("Order Summary")}
            fontSize={"var(--dashboard_tabs-font-size)"}
            className={styles.Heading}
          />
          <div className={styles.Box}>
            {OrderSummary.map((item, index) => {
              return (
                <div key={item?.id} className={styles.ItemDiv}>
                  <TextComponent
                    text={item.title}
                    className={styles.SubHeading}
                  />
                  <TextComponent
                    text={item.title_2}
                    className={styles.Card_Text}
                  />
                </div>
              );
            })}
          </div>
          <HeadingComponent
            fontSize={"var(--dashboard_tabs-font-size)"}
            text={t("Customer Overview")}
            className={styles.Heading}
          />
          <div className={styles.Box}>
            {CustomerOverview.map((item, index) => {
              return (
                <div key={item?.id} className={styles.ItemDiv}>
                  <TextComponent
                    text={item.title}
                    className={styles.SubHeading}
                  />
                  <TextComponent
                    text={item.title_2}
                    className={styles.Card_Text}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.rightCont}>
          <HeadingComponent
            fontSize={"var(--dashboard_tabs-font-size)"}
            text={t("Ordered Products")}
            className={styles.Heading}
          />
          {OrderedProducts.map((item, index) => {
            return (
              <div key={item?.id} className={styles.Card}>
                <div className={styles.row} onClick={() => handleToggle(index)}>
                  <HeadingComponent
                    fontSize={"var(--paragraph-font-size)"}
                    text={item?.title}
                    className={styles.ItemHeading}
                  />
                  <div>
                    {expandedIndex === index ? (
                      <IoArrowUpCircleOutline
                        size={22}
                        cursor={"pointer"}
                        color="var(--primary-color)"
                      />
                    ) : (
                      <IoArrowDownCircleOutline
                        size={22}
                        cursor={"pointer"}
                        color="var(--primary-color)"
                      />
                    )}
                  </div>
                </div>
                {expandedIndex === index && (
                  <>
                    <div className={styles.row}>
                      <TextComponent
                        text={"Quantity"}
                        className={styles.SubHeading}
                      />
                      <TextComponent
                        text={item?.Quantity}
                        className={styles.Card_Text}
                      />
                    </div>
                    <div className={styles.row}>
                      <TextComponent
                        text={"Linked Recipe"}
                        className={styles.SubHeading}
                      />
                      <SubmitButton
                        title={"View Recipe"}
                        textStyle={{ fontSize: "var(--mobile-font)" }}
                        btnClass={styles.ViewJourneyButton}
                        btnContainerClass={styles.ViewJourneybtnContainerClass}
                        primary
                        textClass={styles.EditButtonText}
                        onClick={() => navigate("/RecipeManagement/CreateRecipe")}
                      />
                    </div>
                    <div className={styles.row}>
                      <TextComponent
                        text={"Assigned Batch Code"}
                        className={styles.SubHeading}
                      />
                      <TextComponent
                        text={item?.AssignedBatchCode}
                        className={styles.Card_Text}
                      />
                    </div>
                    <div className={styles.row}>
                      <TextComponent
                        text={"Current Status"}
                        className={styles.SubHeading}
                      />
                      <TextComponent
                        text={item?.CurrentStatus}
                        className={styles.Card_Text}
                      />
                    </div>
                    <div className={styles.row}>
                      <TextComponent
                        text={"Product Journey"}
                        className={styles.SubHeading}
                      />
                      <SubmitButton
                        title={"View Journey"}
                        onClick={() => navigate("/AdminCustomerManagement/OrderHistoryProductJourney")}
                        textStyle={{ fontSize: "var(--mobile-font)" }}
                        btnClass={styles.ViewJourneyButton}
                        btnContainerClass={styles.ViewJourneybtnContainerClass}
                        primary
                        textClass={styles.EditButtonText}
                      />
                    </div>
                    <div >
                      <SubmitButton
                        title={"Cancel Product"}
                        btnClass={styles.CancelButton}
                        // btnContainerClass={styles.CancelbtnContainerClass}
                        onClick={() => setProductModal(true)}
                        secondary
                      />
                      {/* <SubmitButton
                        title={"Edit Order"}
                        btnClass={styles.EditButton}
                        btnContainerClass={styles.EditbtnContainerClass}
                        primary
                      /> */}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* ============ Cancel Modal ===================== */}

      <Modal
        open={CancelModal}
        onCancel={() => {
          setCancelModal(false);
        }}
        onClickOkButton={() => {
          setCancelModal(false);
        }}
        className={styles.Modal}
        // width={"90%"}
        twoButton
        buttonTitle={"Cancel Order"}
        onBtnPress={() => setCancelModal(false)}
        title={"Cancel Order?"}
      >
        {/* <HeadingComponent
          text={"Cancel Order?"}
          fontSize={20}
          textAlign={"center"}
        /> */}


        <TextComponent
          style={{ textAlign: "center" }}
          text="Are you sure you want to cancel this order? This action cannot be undone."
        />
      </Modal>



      {/* ============ Cancel Product ===================== */}

      <Modal
        open={ProductModal}
        onCancel={() => {
          setProductModal(false);
        }}
        onClickOkButton={() => {
          setProductModal(false);
        }}
        className={styles.Modal}
        // width={"90%"}
        twoButton
        buttonTitle={"Cancel Product "}
        onBtnPress={() => setProductModal(false)}
        title={"Cancel Product ?"}
      >
        {/* <HeadingComponent
          text={"Cancel Order?"}
          fontSize={20}
          textAlign={"center"}
        /> */}


        <TextComponent
          style={{ textAlign: "center" }}
          text="Are you sure you want to cancel this product? This action cannot be undone."
        />
      </Modal>
    </div>
  );
};

export default OrderHistoryDetails;
